"use client";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function CustomSlider({
  slides = [],
  spaceBetween = 30,
  autoplay = true,
  delay = 5000,
  loop = true,
  pagination = true,
  navigation = false,
  effect = "slide",
  className = "",
  imgClass = "",
}) {
  return (
    <Swiper
      spaceBetween={spaceBetween}
      loop={loop}
      effect={effect}
      autoplay={
        autoplay
          ? { delay: delay, disableOnInteraction: false }
          : false
      }
      pagination={pagination ? { clickable: true } : false}
      navigation={navigation}
      modules={[Autoplay, Pagination, Navigation, EffectFade]}
      className={className}
    >
      {slides.map((item, index) => (
        <SwiperSlide key={index}>
          <img
            src={item.img}
            alt={item.alt || `slide-${index}`}
            className={`w-full ${imgClass}`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}